export default __webpack_public_path__ + "static/media/023-radar.84630210.png";